import { ReactElement } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { Arguments } from '@dnd-kit/sortable/dist/hooks/useSortable';

export const Draggable = ({
  children,
  ...props
}: Arguments & { children: (props: ReturnType<typeof useSortable>) => ReactElement }) => {
  const draggableProps = useSortable(props);

  return children(draggableProps);
};
